import $ from './jquery';
import { Owl as OwlCarousel } from '../vendor/owl-carousel-2.1.6';
import '../vendor/owl-navigation-2.1.0';
import '../vendor/owl-autoheight-2.1.0';
import '../vendor/owl-autoplay-2.1.0';
import '../vendor/owl-animate-2.1.0';
import '../vendor/owl-outerstage-1.0.0';

const baseConfig = {
  baseClass: 'shop-slider',
  itemClass: 'shop-slider__item',
  loadingClass: 'shop-slider--loading',
  loadedClass: 'shop-slider--loaded',
  stageClass: 'shop-slider__stage',
  stageOuterClass: 'shop-slider__stage__outer',
  dragClass: 'shop-slider--drag',
  grabClass: 'shop-slider--grab',
  autoHeightClass: 'shop-slider--autoheight',
  navContainer: '.shop-slider__navigation',
  navContainerClass: 'shop-slider__navigation',
  navClass: ['shop-slider__navigation__prev', 'shop-slider__navigation__next'],
  dotsClass: 'shop-slider__dots',
  dotClass: 'shop-slider__dots__dot',
  navText: ['', ''],
  items: 1,
  nav: true,
  slideBy: 1,
  smartSpeed: 400,
};

const createSliderConfig = (config) => {
  const sliderConfig = $.extend({}, baseConfig, config);
  return sliderConfig;
};

export default class Slider {
  constructor($el, config) {
    this.$el = $el;

    this.$el.on('initialized.owl.carousel', (e) => {
      this.$el.trigger('initialized.slider.shop', { index: e.item.index || 0 });
    });

    this.$el.on('initialized.owl.navigation', (e) => {
      this.$el.trigger('initialized.navigation.slider.shop', { index: e.item.index || 0 });
    });

    this.$el.on('refreshed.owl.carousel', () => {
      this.$el.trigger('refreshed.slider.shop');
    });

    this.$el.on('translate.owl.carousel', (e) => {
      this.$el.trigger('translate.slider.shop', { index: e.item.index || 0 });
    });

    this.$el.on('translated.owl.carousel', (e) => {
      this.$el.trigger('translated.slider.shop', { index: e.item.index || 0 });
    });

    this.$el.on('changed.owl.carousel', (e) => {
      this.$el.trigger('changed.slider.shop', { index: e.relatedTarget.relative(e.item.index || 0) });
    });

    this.$el.on('resize.owl.carousel', () => {
      this.$el.trigger('resize.slider.shop');
    });

    this.$el.on('resized.owl.carousel', () => {
      this.$el.trigger('resized.slider.shop');
    });

    this.config = createSliderConfig(config);
    if (!$.support.transform3d) this.config.mouseDrag = false;
    this.carousel = new OwlCarousel(this.$el, this.config);
  }

  goToSlide(index) {
    this.carousel.to(index);
  }

  goToPrev() {
    this.carousel.prev();
  }

  goToNext() {
    this.carousel.next();
  }

  destroy() {
    this.carousel.destroy();
    this.$el.off('.owl.carousel');
  }
}
